/* eslint-disable @typescript-eslint/naming-convention */
export enum TableTypeEnum {
	DataTable,
	RefTable
}
